import React from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import styles from "../../../../BorrowerDetails.module.css";
import Pdf from "../../../../../../../assets/PDF_icon.svg";
import { useState } from "react";
import PDFViewer from "../../../PDFViewer/PDFViewer";
import { useBorrowerContext } from "../../../../store/borrower-details";
import { useEffect } from "react";
import KeyIcon from "@mui/icons-material/Key";
import EnlargeDocModal from "../../../Modals/EnlargeDocModal";

const CoapplicantMultiDocs = ({
  name,
  doc,
  download,
  pdfPassword,
  deleteDoc,
  isDisbursed,
}) => {
  const [pdfModal, setPdfModal] = useState({
    open: false,
    data: "",
  });
  const [passwordProtected, setPasswordProtected] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const [enlargeImage, setEnlargeImage] = useState(false);
  const [imageData, setImageData] = useState({});

  useEffect(() => {
    if (name === "Bank Statement") {
      setPasswordProtected(true);
    }
  }, [name]);
  const { contextMenuHandler } = useBorrowerContext();

  const viewPdfHandler = (url) => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: true,
      data: `data:application/pdf;base64,${url}`,
    }));
  };

  const closePdfViewer = () => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: false,
      data: "",
    }));
  };

  const pdfPasswordHandler = () => {
    setShowPassword(!showPassword);
  };

  const enlargeImageHandler = (data) => {
    setImageData(data);
    setEnlargeImage(true);
  };

  const closeEnlargeImage = () => {
    setEnlargeImage(false);
  };

  return (
    <>
      {pdfModal.open && (
        <PDFViewer url={pdfModal.data} closeModal={closePdfViewer} />
      )}
      {enlargeImage && (
        <EnlargeDocModal
          docType={imageData.docType}
          doc={imageData.doc}
          closeModal={closeEnlargeImage}
        />
      )}
      <div>
        <Accordion>
          <AccordionSummary>
            <h5>{name}</h5>
          </AccordionSummary>
          <AccordionDetails>
            <div className={styles.coappMultiDocContainer}>
              {doc?.map((data, index) => {
                return data.docType !== "pdf" ? (
                  <div className={styles.bankStatement} key={index}>
                    {data.doc && (
                      <div>
                        <section>
                          <img
                            key={index}
                            onContextMenu={contextMenuHandler}
                            draggable={false}
                            src={`data:image/${data.docType};base64,${data.doc}`}
                            alt=""
                            className={styles.docsImg}
                            onClick={() => enlargeImageHandler(data)}
                          />
                        </section>
                        <button
                          onClick={() => download(data.apiName, data.docType)}
                        >
                          Download
                        </button>
                        {!isDisbursed && (
                          <button
                            style={{ marginTop: "1vh", backgroundColor: "red" }}
                            onClick={() =>
                              deleteDoc(
                                data.apiName,
                                data.docType,
                                data.location
                              )
                            }
                          >
                            Delete
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div key={index}>
                    <section>
                      <img
                        src={Pdf}
                        alt=""
                        className={styles.docsPDF}
                        onClick={() => viewPdfHandler(data.doc)}
                      />
                    </section>
                    <button
                      onClick={() => download(data.apiName, data.docType)}
                    >
                      Download
                    </button>
                    {!isDisbursed && (
                      <button
                        style={{ marginTop: "1vh", backgroundColor: "red" }}
                        onClick={() =>
                          deleteDoc(data.apiName, data.docType, data.location)
                        }
                      >
                        Delete
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          </AccordionDetails>
          {passwordProtected && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                marginBottom: "2vh",
                gap: "1vh",
              }}
            >
              <KeyIcon
                onClick={pdfPasswordHandler}
                style={{ cursor: "pointer" }}
              />
              {showPassword && <h5>{pdfPassword}</h5>}
            </div>
          )}
        </Accordion>
      </div>
    </>
  );
};

export default CoapplicantMultiDocs;
